/** @jsx jsx */
import { memo } from 'react';
import { IconButton } from '@atlaskit/button/new';
import SyncIcon from '@atlaskit/icon-lab/core/sync';
import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const SaveResetViewSettingsButtonUI = memo(() => {
	const { formatMessage } = useIntl();

	return (
		<div css={styles.root}>
			<IconButton
				icon={SyncIcon}
				isTooltipDisabled={false}
				label={formatMessage(messages.saveOrResetViewSettingsButton)}
			/>
		</div>
	);
});

const styles = cssMap({
	root: {
		display: 'flex',
		// this allows to have the gap between action buttons being animated properly upon reveal/hide
		paddingLeft: token('space.100'),
		width: '32px',
	},
});
